/**
 * Transforms normalized coordinates (0-1 range) to pixel coordinates
 * @param normalizedCoords - Array of normalized coordinates in format [[[x1,y1], [x2,y2], ...], ...]
 * @param imageWidth - Width of the image in pixels
 * @param imageHeight - Height of the image in pixels
 * @returns Array of pixel coordinates
 */
export const transformNormalizedToPixelCoordinates = (
  normalizedCoords: number[][][],
  imageWidth: number,
  imageHeight: number
): number[][][] => {
  return normalizedCoords.map((polygon) =>
    polygon.map(([x, y]) => [x * imageWidth, y * imageHeight])
  );
};

/**
 * Transforms pixel coordinates to normalized coordinates (0-1 range)
 * @param pixelCoords - Array of pixel coordinates in format [[[x1,y1], [x2,y2], ...], ...]
 * @param imageWidth - Width of the image in pixels
 * @param imageHeight - Height of the image in pixels
 * @returns Array of normalized coordinates
 */
export const transformPixelToNormalizedCoordinates = (
  pixelCoords: number[][][],
  imageWidth: number,
  imageHeight: number
): number[][][] => {
  return pixelCoords.map((polygon) =>
    polygon.map(([x, y]) => [x / imageWidth, y / imageHeight])
  );
};
